import { render, staticRenderFns } from "./BusinessPaymentHistory.vue?vue&type=template&id=fd099f08&"
import script from "./BusinessPaymentHistory.vue?vue&type=script&lang=js&"
export * from "./BusinessPaymentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports